export enum DischargeStatus {
       Regular = 1, 
       Death = 2,
       DoctorPermission = 3,
       AgainstMedicalAdvice = 4,
       Irregular = 5, 
       TransferOut = 6,
       CancelAdmission = 7,
       Absconded = 8,
}
